import { ok, Result } from 'neverthrow';
import { GraphError, ToolItem, ToolNode } from './types';

export const resolveTool = (
  node: ToolNode
): Result<ToolItem, { err: GraphError; partial: null }> => {
  const { def } = node;

  const defItem: ToolItem['def'] = {
    t: 'ffi',
    type: def.type,
    toolId: def.toolId,
    toolConnectionId: def.toolConnectionId,
  };

  const res: ToolItem = {
    t: 'tool',
    def: defItem,
  };

  return ok(res);
};
